module.exports = ".btn-submit {\r\n    width: 200px;\r\n}\r\n\r\n.player-height-feet {\r\n    position: relative;\r\n}\r\n\r\n.player-height-feet:after {\r\n    content: 'ft';\r\n    position: absolute;\r\n    top: 12px;\r\n    right: 5px;\r\n}\r\n\r\n.player-height-inch {\r\n    position: relative;\r\n}\r\n\r\n.player-height-inch:after {\r\n    content: 'in';\r\n    position: absolute;\r\n    top: 12px;\r\n    right: 5px;\r\n}\r\n\r\n.photo {\r\n    max-height: 200px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/questions/all-questions/all-questions.component.css
// module id = ./src/app/shared/components/questions/all-questions/all-questions.component.css
// module chunks = main